import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Touch } from 'vuetify/lib/directives'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/sass/variables.sass'

Vue.use(Vuetify, {
  directives: {
    Touch
  }
})

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#38B8FF'
      },
      dark: {
        primary: '#38B8FF'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
}

export default new Vuetify(opts)
